import * as React from 'react';
import { styled } from '@glitz/react';
import { ArrowDown } from 'webapp/components/icons';
import { createFieldSizeDecorator, FieldSize } from 'webapp/components/field-size';

type PropType = Pick<
  React.HTMLAttributes<HTMLSelectElement>,
  Exclude<keyof React.HTMLAttributes<HTMLSelectElement>, 'type' | 'value' | 'className' | 'style'>
> & {
  onChangeOption?: (value: string) => any;
  elementRef?: (el: HTMLSelectElement) => void;
  isMobileFilter?: boolean;
  value: string;
  options: Option[];
};

type Option = {
  value: string; // Replace with a generic
  text: string;
};

function DropDown(props: PropType) {
  const { options = [], onChangeOption, onChange, elementRef, isMobileFilter, ...restProps } = props;

  function customOnChange(e: React.ChangeEvent<HTMLSelectElement>) {
    if (onChange) {
      onChange(e);
    }
    if (onChangeOption) {
      onChangeOption(options[e.currentTarget.selectedIndex].value);
    }
  }

  return isMobileFilter ? (
    <styled.Div>
      <MobileSelect ref={elementRef} onChange={customOnChange} {...restProps}>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </MobileSelect>
    </styled.Div>
  ) : (
    <styled.Div>
      <Select ref={elementRef} onChange={customOnChange} {...restProps}>
        {options.map((option, i) => (
          <option key={i} value={option.value}>
            {option.text}
          </option>
        ))}
      </Select>
      <Toggle />
    </styled.Div>
  );
}

export default styled(DropDown, {
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
});

/** @glitz-dynamic */
export const resetSelectStyle = styled.select({
  appearance: 'none',
  padding: { xy: 0 },
  font: {
    family: 'inherit',
    style: 'inherit',
    variant: 'inherit',
    weight: 'inherit',
    size: 'inherit',
  },
  color: 'inherit',
  border: { xy: { width: 0 } },
  backgroundColor: ['transparent', 'initial'],
  ':focus': {
    outlineWidth: 0,
    outlineStyle: 'none',
  },
});

/** @glitz-dynamic */
const Select = styled(resetSelectStyle, createFieldSizeDecorator(FieldSize.Small), {
  minWidth: '100%',
  paddingRight: t => t.spacing.l,
  fontSize: t => t.fontSize.xxs,
});

/** @glitz-dynamic */
const MobileSelect = styled(resetSelectStyle, createFieldSizeDecorator(FieldSize.Small), {
  minWidth: '100%',
  fontSize: t => t.fontSize.xxs,
});

const Toggle = styled(ArrowDown, {
  position: 'absolute',
  right: 0,
  pointerEvents: 'none',
});
